import { defineAction, object } from '~/prix'
import communityUpdateAction from './geoCommunityUpdate.action.json' with { type: 'json' }
// import { communityObject } from '../geoCommunityObject'
// import { z } from 'zod'

const communityUpdateDefinition = defineAction({
  ...communityUpdateAction,

  // input: communityObject,
  // output: z.object({}),

  input: object<any>({}),
  output: object<any>({}),
})

export default communityUpdateDefinition
